import React, { FunctionComponent } from "react";
import styles from "./Employee.module.scss";
import EmployeeProps from "./EmployeeProps.interface";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import getImageCrop from "app/media/helpers/getImageCrop";
import IconViewer from "components/IconViewer/IconViewer";

const Employee: FunctionComponent<EmployeeProps> = (props) => {
    const imageCrop = getImageCrop(props.media?.umbracoFile.crops, undefined, "Square (1:1)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, props.media?.umbracoWidth, props.media?.umbracoHeight);

    return (
        <div className={styles.wrapper}>
            <div className={styles.inner}>
                {props.media ? (
                    <ImageViewer className={styles.image} src={props.media.umbracoFile.src} crop={imageCrop} focalPoint={props.media.umbracoFile.focalPoint} alt={props.fullName} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                ) : null}

                <div className={styles.content}>
                    {props.fullName ? (
                        <h3 className={styles.heading}>{props.fullName}</h3>
                    ) : null}

                    {props.title ? (
                        <p className={styles.title}>{props.title}</p>
                    ) : null}
                    {props.description ? (
                        <p className={styles.description}>{props.description}</p>
                    ) : null}

                    <div className={styles.contact}>
                        {props.email ? (
                            <div className={styles.email}>
                                <IconViewer className={styles.email_icon} name="email" />
                                <a className={styles.email_link} href={`mailto:${props.email}`}>{props.email}</a>
                            </div>
                        ) : null}

                        {props.phone ? (
                            <div className={styles.phone}>
                                <IconViewer className={styles.phone_icon} name="phone" />
                                <a className={styles.phone_link} href={`tel:${props.phone}`}>{props.phone}</a>
                            </div>
                        ) : null}

                        {props.socialLinkedinUrl ? (
                            <div className={styles.linkedin}>
                                <IconViewer className={styles.linkedin_icon} name="linkedin" />
                                <a className={styles.linkedin_link} href={props.socialLinkedinUrl}>Linkedin</a>
                            </div>
                        ) : null}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Employee;